import { type TruckType } from '../domain/Truck'
import { type IconName } from '../ui/components/icon/Icon'

export function getTruckIconName(truckType: TruckType): IconName | undefined {
  switch (truckType) {
    case 'BTR':
      return 'truck-box'
    case 'CON':
      return 'truck-conestoga'
    case 'CUR':
      return 'truck-courtainside'
    case 'DDP':
      return 'truck-double-drop'
    case 'DRB':
      return 'truck-container'
    case 'DRV':
      return 'truck-dryvan'
    case 'FBE':
      return 'truck-flatbed'
    case 'FRA':
      return 'truck-flatrack'
    case 'HOT':
    case 'HST':
      return 'truck-hotshot'
    case 'IMC':
      return 'truck-container'
    case 'LTL':
      return 'truck-ltl-dryvan'
    case 'RFR':
      return 'truck-reefer'
    case 'RORO':
      return 'truck-rollon-rolloff'
    case 'SBT':
      return 'truck-straight'
    case 'SDK':
      return 'truck-stepdeck'
    case 'SPR':
      return 'truck-sprinter'
    case 'STR':
    case 'STK':
      return 'truck-straight'
    case 'SUPB':
      return 'truck-dryvan'
    case 'CONTAINER':
    case 'TANK_CAR':
    case 'TRAILER':
      return 'truck-container'
    case 'BLK':
    case 'OTH':
    case 'TNK':
    case 'CGV':
    default:
      return undefined
  }
}

export function getTruckLabel(truckType: TruckType): string | undefined {
  switch (truckType) {
    case 'BTR':
      return 'Box Truck'
    case 'CGV':
      return 'Cargo Van'
    case 'CON':
      return 'Conestoga'
    case 'CUR':
      return 'Curtainside'
    case 'DDP':
      return 'Double Drop'
    case 'DRB':
      return 'Dry Box'
    case 'DRV':
      return 'Dry Van'
    case 'FBE':
      return 'Flatbed'
    case 'FRA':
      return 'Flat Rack'
    case 'HOT':
    case 'HST':
      return 'Hotshot'
    case 'IMC':
      return 'Intermodal'
    case 'LTL':
      return 'Less than Truckload'
    case 'RFR':
      return 'Reefer'
    case 'RORO':
      return 'Roll on Roll off'
    case 'SBT':
      return 'Straight Box Truck'
    case 'SDK':
      return 'Step Deck'
    case 'SPR':
      return 'Sprinter'
    case 'STR':
    case 'STK':
      return 'Straight Truck'
    case 'WF':
      return 'Walking Floor'
    case 'DT':
      return 'Dump Truck'
    case 'OT':
      return 'Open Top'
    case 'SUPB':
      return 'SuperB'
    case 'CONTAINER':
      return 'Container'
    case 'TANK_CAR':
      return 'Tank Car'
    case 'TRAILER':
      return 'Trailer'
    case 'BLK':
    case 'OTH':
    case 'TNK':
    default:
      return undefined
  }
}
